import { quoteCardInstallment } from "../../pricing/paymentInstallmentsPricing";

/** Hubwayz hotel checkout order. Card amount is a slice of the customer sale, not a second fee. */
export function isHubwayzCheckoutOrder(order) {
  if (!order || typeof order !== "object") return false;
  const pricing =
    order.pricecalculations || order.priceCalculations || order.price_calculations;
  if (pricing && typeof pricing === "object" && pricing.hubwayz_fx && typeof pricing.hubwayz_fx === "object") {
    return true;
  }
  const supplier = String(order.supplier || order.supplier_name || "").toLowerCase();
  if (supplier === "hubwayz") return true;
  const audit = order.post_booking_audit;
  if (audit && typeof audit === "object" && String(audit.supplier || "").toLowerCase() === "hubwayz") {
    return true;
  }
  const packageId = String(order.packageid || order.packageId || "").toLowerCase();
  return packageId.startsWith("hubwayz:");
}

/**
 * One card's HYP charge. Principal is the amount the agent typed.
 * Interest is calculated once from the interest table on that principal.
 */
export function resolveHubwayzCardCharge({ card, cards, balanceIls, interestTable } = {}) {
  const balance = Math.ceil(Number(balanceIls) || 0);
  const principal = Math.ceil(Number(card?.amount) || 0);
  const tash = Math.max(1, Math.floor(Number(card?.numberofpayments) || 1));
  const allocated = (Array.isArray(cards) ? cards : []).reduce((sum, item) => {
    if (!item || item.paid) return sum;
    const value = Math.ceil(Number(item.amount) || 0);
    return sum + (value > 0 ? value : 0);
  }, 0);
  if (!(principal > 0) || (balance > 0 && (principal > balance || allocated > balance))) {
    return {
      ok: false,
      error: "סכום התשלום חייב להיות חיובי ולא לעבור את היתרה",
      actualAmount: null,
      amount: null,
      tash,
      interestIls: null,
    };
  }
  const quote = quoteCardInstallment({
    principalIls: principal,
    numberOfPayments: tash,
    interestTable,
  });
  if (!quote.ok) {
    return {
      ok: false,
      error: quote.error || "לא ניתן לחשב ריבית תשלומים",
      actualAmount: null,
      amount: null,
      tash,
      interestIls: null,
      rateMissing: Boolean(quote.rateMissing),
    };
  }
  return {
    ok: true,
    error: null,
    actualAmount: principal,
    amount: quote.amountWithInterest,
    tash,
    interestIls: quote.paymentInterest,
    perPaymentIls: quote.perPaymentIls,
    rateMissing: false,
  };
}
